import React, { useEffect } from "react";
import { useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

interface ErrorItems {
  table: string;
  row: string;
  code: string;
  msg: string;
}

interface IFileInputs {
  UI: JSX.Element;
  fileExtension?: string;
  onChange: (file: FormData | null) => void;
  label: string;
  value: FormData | null;
  name: string;
  className?: string;
}

const FileInput = ({
  UI,
  fileExtension,
  onChange,
  label,
  value,
  name,
  className,
}: IFileInputs) => {
  const [dragActive, setDragActive] = React.useState<boolean>(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const [file, setFile] = useState<File | null>(null);

  useEffect(() => {
    if (!value) setFile(null);
  }, [value]);

  const handleDrag = function (e: any) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const changeHandler = (file: File) => {
    setFile(file);
    const data = new FormData();
    data.append(name, file, file.name);
    onChange(data);
  };

  const handleDrop = function (e: any) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      changeHandler(e.dataTransfer.files[0]);
    }
  };

  const handleChange = function (e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.files && e.target.files[0]) {
      changeHandler(e.target.files[0]);
    }
  };

  const onButtonClick = () => {
    if (value) return;
    if (inputRef.current) {
      inputRef.current.value = "";
      inputRef.current.click();
    }
  };

  return (
    <div
      className={`cursor-pointer flex flex-row justify-between items-center gap-8 w-full text-xs border-2 text-gray-400 border-gray-200 rounded px-2 py-1 hover:text-primary hover:border-primary hover:transition-all ${
        dragActive ? "bg-gray-200" : null
      } ${className}`}
      onDragEnter={handleDrag}
      onDragLeave={handleDrag}
      onDragOver={handleDrag}
      onDrop={handleDrop}
      onSubmit={(e) => e.preventDefault()}
      onClick={onButtonClick}
    >
      {/* {value ? (
        <a
          href={value}
          download
          className="absolute w-full h-full inset-0 bg-cyan-100"
        ></a>
      ) : null} */}
      <input
        accept={fileExtension}
        aria-label={label}
        ref={inputRef}
        type="file"
        className="hidden"
        multiple={false}
        onChange={handleChange}
      />

      {file && file.name ? (
        <div className="p-auto">{file.name}</div>
      ) : (
        <div className="w-full">
          {UI}
          <div className="text-inherit text-center">
            {dragActive ? "فایل را رها کنید" : label}
          </div>
        </div>
      )}

      {file?.name ? (
        <div
          className="x-btn"
          onClick={() => {
            onChange(null);
            setFile(null);
          }}
        >
          <CloseIcon
            fontSize="small"
            className="text-gray-500 hover:text-gray-700 transition-all"
          />
        </div>
      ) : null}
    </div>
  );
};

export default FileInput;
